import React from 'react';
import { motion } from 'framer-motion';
const bonuses = [{
  icon: '📨',
  title: 'Kit de Comunicación con Familias'
}, {
  icon: '📋',
  title: 'Banco de Rúbricas Express'
}, {
  icon: '📅',
  title: 'Planificador Visual Anual'
}, {
  icon: '🧭',
  title: 'Protocolos de Intervención'
}, {
  icon: '📊',
  title: 'Fichas de Seguimiento Individual'
}, {
  icon: '🗂️',
  title: 'Organizador Docente Digital'
}];
export function BonusSection() {
  return <section className="py-20 bg-white" data-id="element-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-17">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-18">
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-4" data-id="element-19">
            + 6 Bonos para llevar tu práctica psicopedagógica al siguiente nivel
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-20">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-brand-50 rounded-2xl p-6 border border-brand-100 flex items-start gap-4" data-id="element-21">
              <div className="text-4xl bg-white w-16 h-16 rounded-xl flex items-center justify-center shadow-sm shrink-0" data-id="element-22">
                {bonus.icon}
              </div>
              <div data-id="element-23">
                <h3 className="font-bold text-gray-900 mb-2 leading-tight" data-id="element-24">
                  {bonus.title}
                </h3>
                <div className="flex items-center gap-2" data-id="element-25">
                  <span className="text-gray-400 line-through text-sm" data-id="element-26">
                    $15.000
                  </span>
                  <span className="bg-success-light text-success font-bold text-xs px-2 py-1 rounded-md uppercase" data-id="element-27">
                    Gratis
                  </span>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="max-w-2xl mx-auto bg-gray-900 rounded-2xl p-6 text-center shadow-xl" data-id="element-28">
          <p className="text-gray-400 font-medium mb-1" data-id="element-29">
            Valor total de los bonos:
          </p>
          <div className="flex items-center justify-center gap-3 text-3xl md:text-4xl font-black" data-id="element-30">
            <span className="text-gray-500 line-through" data-id="element-31">$90.000</span>
            <span className="text-success" data-id="element-32">GRATIS</span>
          </div>
        </motion.div>
      </div>
    </section>;
}